import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link, Redirect} from 'react-router-dom';
import Overlay from '../../Miscelania/Overlay';
import Select from 'react-select';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class TrainingAvaliationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: '',
      clareza_dos_objetivos: 0,
      programa_proposto: 0,
      sistema_de_iscricao: 0,
      homogeniedade_do_grupo: 0,
      cumprimento_do_horario: 0,
      cumprimento_do_programa: 0,
      carga_horaria_realizada: 0,
      atingimento_dos_objetivos: 0,
      aplicabilidade_do_conteudo: 0,
      qualidade_do_conteudo: 0,
      quantidade_do_conteudo_teorico: 0,
      quantidade_do_conteudo_pratico: 0,
      quantidade_do_material_instrucional: 0,
      qualidade_do_material_instrucional: 0,
      atendimento_das_expectativas: 0,
      dominio_do_assunto: 0,
      clareza_e_objetividade: 0,
      estimulo_a_participacao_do_grupo: 0,
      adequacao_das_tecnicas_didaticas: 0,
      comunicacao_e_linguagem: 0,
      comentarios: null,
      training_avaliation_staffs: [],
    };
    this.gerarRelatorio = this.gerarRelatorio.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleRadioChange (name, event) {
    var change = {};
    change[event] = name;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_avaliation_staffs)){
      this.setState({
        training_avaliation_staffs: newProps.training_avaliation_staffs,
      });
    }
    if(typeof newProps.training_id !== 'undefined'){
      this.setState({
        training_id: newProps.training_id,
        training_certifications_list: newProps.training_certifications_list,
        training_certification_staffs_list: newProps.training_certification_staffs_list,
      });
    }
  }
  
  gerarRelatorio(event) {
    event.preventDefault();
    var datasave = {
      publico_alvo: this.state.publico_alvo,
      pre_requisito: this.state.pre_requisito,
      objetivos: this.state.objetivos,
      fonte_treinamento: this.state.fonte_treinamento,
      metodo_treinamento: this.state.metodo_treinamento,
      recursos_didaticos: this.state.recursos_didaticos,
      forma_avaliacao: this.state.forma_avaliacao,
      training_certification_id: this.state.training_certification_id_relatorio,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/gerar/avaliacao/geral', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });   
  }

  ActionsButtons (cell, row) {
    var url = '/ocorrencia/anormal/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var training_avaliation_staff_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa avaliação?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/avaliacao/deletar/' + training_avaliation_staff_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(training_avaliation_staff_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(training_avaliation_staff_id) {
    var training_avaliation_staffs = this.state.training_avaliation_staffs;
    training_avaliation_staffs.map(function(dado, index){
      if (dado.id == training_avaliation_staff_id) {
        training_avaliation_staffs.splice(index, 1);
      }
    });
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.props.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <h3 className="page-title">Avaliações</h3>
  <hr/>
  <BootstrapTable data={this.state.training_avaliation_staffs} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Nenhuma avaliação para este treinamento.'}} search={true} multiColumnSearch={true} searchPlaceholder="Procurar">

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width="60">ID</TableHeaderColumn>

    <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Colaborador</TableHeaderColumn>

    <TableHeaderColumn dataField="certification_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Certificado</TableHeaderColumn>

    <TableHeaderColumn dataField="nota_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Nota</TableHeaderColumn>

    <TableHeaderColumn dataField="nota_total_instrutor" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Nota Instrutor</TableHeaderColumn>

    <TableHeaderColumn dataField="clareza_dos_objetivos_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Clareza dos Objetivos</TableHeaderColumn>

    <TableHeaderColumn dataField="programa_proposto_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Programa Proposto</TableHeaderColumn>

    <TableHeaderColumn dataField="sistema_de_inscricao_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Sistema de Inscrição</TableHeaderColumn>

    <TableHeaderColumn dataField="homogeniedade_do_grupo_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Homogeneidade do Grupo</TableHeaderColumn>

    <TableHeaderColumn dataField="cumprimento_do_horario_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Cumprimento do Horário</TableHeaderColumn>

    <TableHeaderColumn dataField="cumprimento_do_programa_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Cumprimento do Programa</TableHeaderColumn>

    <TableHeaderColumn dataField="carga_horaria_realizada_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Carga Horária Realizada</TableHeaderColumn>

    <TableHeaderColumn dataField="atingimento_dos_objetivos_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Atingimento dos Objetivos</TableHeaderColumn>

    <TableHeaderColumn dataField="aplicabilidade_do_conteudo_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Aplicabilidade do Conteúdo</TableHeaderColumn>

    <TableHeaderColumn dataField="qualidade_do_conteudo_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Qualidade do Conteúdo</TableHeaderColumn>

    <TableHeaderColumn dataField="quantidade_do_conteudo_teorico_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Quantidade do Conteúdo Teórico</TableHeaderColumn>

    <TableHeaderColumn dataField="quantidade_do_conteudo_pratico_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Quantidade do Conteúdo Prático</TableHeaderColumn>
    
    <TableHeaderColumn dataField="quantidade_do_material_instrucional_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Quantidade do Material</TableHeaderColumn>

    <TableHeaderColumn dataField="qualidade_do_material_instrucional_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Qualidade do Material</TableHeaderColumn>

    <TableHeaderColumn dataField="atendimento_das_expectativas_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Atendimento das Expectativas</TableHeaderColumn>

    <TableHeaderColumn dataField="dominio_do_assunto_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Domínio do Assunto</TableHeaderColumn>

    <TableHeaderColumn dataField="clareza_e_objetividade_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Clareza e Objetividade</TableHeaderColumn>

    <TableHeaderColumn dataField="estimulo_a_participacao_do_grupo_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Estímulo à Participação</TableHeaderColumn>

    <TableHeaderColumn dataField="adequacao_das_tecnicas_didaticas_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Adequação das Técnicas</TableHeaderColumn>

    <TableHeaderColumn dataField="comunicacao_e_linguagem_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Comunicação e Linguagem</TableHeaderColumn>

    <TableHeaderColumn dataField="comentarios" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="120">Comentários e Sugestões</TableHeaderColumn>

    {/* <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width="100">Ações</TableHeaderColumn> */}

  </BootstrapTable>
</div>
    );
  }
}

export default TrainingAvaliationsTab;


// WEBPACK FOOTER //
// ./src/Components/Teams/Elements/TrainingAvaliationsTab.js